import React from 'react'
import { Layout } from 'antd'
import { format } from 'date-fns-tz'
import styles from './Footer.module.css'

const { Footer: FooterLayout } = Layout

export const Footer: React.FC = () => {
  const currentYear = format(new Date(), 'yyyy', { timeZone: 'UTC' })

  return <FooterLayout className={styles.footer}>Lattice © {currentYear}</FooterLayout>
}
